export default {
    Metadata: {
        Name: "IsMobileDevice",
        Description: "Returns a boolean. True if the browser is being used by a mobile device, otherwise False",
        Syntax: "IsMobileDevice()",
        Keywords: ['Browser'],
        Author: "DataVoke, Inc.",
    },
    execute() {
        return api.isMobileDevice();
    },
};
